import React, {Component} from 'react'

class ImageElement extends Component {
  constructor(props) {
    super(props)
  }
  
  render() {
    return (
      <>
        {
          this.props.image ? <picture>
            <source media="(min-width:2800px)" srcset={`${this.props.image}&width=1800`} />
            <source media="(min-width:2560px)" srcset={`${this.props.image}&width=1600`} />
            <source media="(min-width:2400px)" srcset={`${this.props.image}&width=1400`} />
            <source media="(min-width:1920px)" srcset={`${this.props.image}&width=1200`} />
            <source media="(min-width:1600px)" srcset={`${this.props.image}&width=1024`} />
            <source media="(min-width:1440px)" srcset={`${this.props.image}&width=900`} />
            <source media="(min-width:1280px)" srcset={`${this.props.image}&width=800`} />
            <source media="(min-width:1024px)" srcset={`${this.props.image}&width=700`} />
            <source media="(min-width:768px)" srcset={`${this.props.image}&width=1200`} />
            <source media="(min-width:700px)" srcset={`${this.props.image}&width=1024`} />
            <source media="(min-width:600px)" srcset={`${this.props.image}&width=800`} />
            <source media="(min-width:450px)" srcset={`${this.props.image}&width=700`} />
            <source media="(min-width:360px)" srcset={`${this.props.image}&width=550`} />
            <source media="(min-width:300px)" srcset={`${this.props.image}&width=450`} />
            <img
              src={`${this.props.image}&width=450`}
              className="block w-full h-auto"
              fetchpriority="high"
              alt="Region Image for Thom Browne eyewear stores"
            />
          </picture> : null
        }
      </>
    )
  }
}

export default ImageElement